import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { EMailAudit } from 'src/app/lib/mail/classes';
import { MailService } from 'src/app/lib/mail/services/mail.service';
import { IIssueAuditWrapperProvider, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';

@Component({
  selector: 'app-issue-audit-email',
  templateUrl: './issue-audit-email.component.html',
  styleUrls: ['./issue-audit-email.component.css']
})
export class IssueAuditEmailComponent implements OnDestroy, OnInit {

  private _audit = new ReplaySubject<EMailAudit[]>(1);
  @Input() set eMailAudit(audit: EMailAudit[]) {
    audit.filter(x => x.htmlBody).forEach(x => this._mailService.resolveEMailCids(x, timer(2000)));
    this._audit.next(audit);
  }

  incomingMails$ = this._audit.pipe(map(x => x.filter(y => y.incoming)));
  outgoingMails$ = this._audit.pipe(map(x => x.filter(y => !y.incoming)));

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProvider: IIssueAuditWrapperProvider,
    private _mailService: MailService
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueAuditWrapperProvider.issueAuditWrapper$.subscribe((wrapper) => this.eMailAudit = wrapper.eMailAudit)
    ]);
  }

}
